import {gql} from "apollo-angular";


export const BRELA_VERIFICATION_MUTATION = gql`
  mutation BrelaVerificationMutation($regNumber: String) {
    brelaVerificationMutation(regNumber: $regNumber) {
      response {
        id
        status
        code
        message
      }
      data {
        id
        uuid
        companyRegNumber
        taxPayerTin
        companyName
        shortForm
        mobPhone
        box
        email
        country
        isVerified
      }
    }
  }
`

export const CREATE_COMPANY_MUTATION = gql`
  mutation CreateCompanyMutation($input: CompanyInputObject) {
    createCompanyMutation(input: $input) {
      response {
        id
        status
        code
        message
      }
      data {
        id
        uuid
        companyRegNumber
        taxPayerTin
        companyName
        shortForm
        mobPhone
        box
        email
        country
        isVerified
      }
    }
  }
`
